export const removeYearFromVersion = (version_name: string) => {
  const splitVersion = version_name.match(/(.*)\[.*\](.*)/);

  if (splitVersion?.length) return splitVersion[1] + splitVersion[2];
  else return version_name;
};
